<template id="challenges-cards">
    <div class="filter">
        <TeamChallengeCards />
        <JackpotChallengeCards />
        <StepChallengeCards />
        <SweepstakesChallengeCards />
    </div>
</template>

<script>
import TeamChallengeCards from './TeamChallengeCards';
import JackpotChallengeCards from './JackpotChallengeCards';
import StepChallengeCards from './StepChallengeCards';
import SweepstakesChallengeCards from './SweepstakesChallengeCards';

export default {
  template: '#challenges-cards',
  components: { TeamChallengeCards, JackpotChallengeCards, StepChallengeCards, SweepstakesChallengeCards }
}
</script>
